// eslint-disable-next-line import/prefer-default-export
export const mapAlertDetail = (item = {}) => {
  const translations = item.translations || []
  return {
    ...item,
    translations: translations.map((t) => ({
      ...t,
      languageId: t.language?.id,
      translationValue: t.translationLabel,
      translationDescription: t.translationDescription
    }))
  }
}
